module.exports = __webpack_public_path__ + "img/choose-chat.6a58804f.png";